<template>
  <div class="bind">
    <div class="table-del" @click="onOpenDialog">解绑</div>
    <el-dialog v-if="dialogVisible" title="达人解绑" :visible.sync="dialogVisible" width="540px" modal-append-to-body
      append-to-body>
      <div class="bind-title">
        是否确定要与达人<span class="color-red">“{{ row.userName }}”</span>解除绑定关系？
      </div>
      <div class="bind-tip">
        <div class="bind-bottom color-pink">
          <div><i class="el-icon-info"></i>注意：</div>
          <div class="bind-weight">
            1、解绑前请先与达人充分沟通确认，避免产生纠纷。
          </div>
          <div>
            2、目前仅支持没有订单的达人进行解绑。
          </div>
          <div>
            3、解绑后，达人再产生的订单将与您无关。
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchFractionalPart1 } from "@/utils/regExp";
const DouYinModel = new douYin();
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },

  },
  data() {
    return {
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框

    };
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.dialogVisible = true;
    },
    // 取消
    onCancel() {
      this.dialogVisible = false;
    },
    // 确定
    async onSure() {
      const data = await DouYinModel.cancelBindMaster({
        reference: this.row.reference
      }).finally(() => {
        this.saveLoading = false;
      });
      if (data.data.code === 200) {
        this.onCancel();
        this.$emit("refresh");
        this.$message.success(data.data.message);
      } else {
        this.$message.error(data.data.message);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bind {
  &-tip {
    background: #FAFAFA;
    padding: 8px;
  }

  &-title {
    font-weight: bold;
    margin: 20px 0;
  }

  &-weight {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/distribution/CancelBind.vue